import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from '@react-pdf/renderer';
import nls from '../../nls/pt-BR.json';
import OpenSansSemiBold from '../../../../../assets/Open_Sans/static/OpenSans/OpenSans-SemiBold.ttf';
import OpenSansNormal from '../../../../../assets/Open_Sans/static/OpenSans/OpenSans-Regular.ttf';
import OpenSansBold from '../../../../../assets/Open_Sans/static/OpenSans/OpenSans-Bold.ttf';
import QuicksandBold from '../../../../../assets/Quicksand/Quicksand-Bold.ttf';
import { Logo } from './components/logo';
import {
  BuildingLayoutDataHeader,
  FrontPageHeader,
} from './components/headers';
import { BuildingLayoutData } from './components';
import { FormattedPDFData, ImgUrls } from './usePDFData';

Font.register({
  family: 'Open Sans Bold',
  src: OpenSansBold,
});

Font.register({
  family: 'Open Sans Semi Bold',
  src: OpenSansSemiBold,
});

Font.register({
  family: 'Open Sans Normal',
  src: OpenSansNormal,
});

Font.register({
  family: 'Quicksand Bold',
  src: QuicksandBold,
});

export enum COLORS {
  primaryTitle = '#925AC4',
  primarySubtitle = '#793EAD',
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFF',
    width: '100%',
    height: '100%',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  alignCenter: {
    alignItems: 'center',
  },

  contentContainer: {
    padding: `0px 24px 
      24px 24px`,
  },
  pageNumber: {
    fontFamily: 'Open Sans Normal',
    fontSize: 16,
  },
  mapImgSectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginBottom: 24,
  },
  mapImgTitle: {
    color: '#1E1E1E',
    fontFamily: 'Open Sans Bold',
    fontSize: 14,
  },
  mapImgContainer: {
    borderRadius: 4,
  },
});

interface ViabilityReportProps {
  imageSources: ImgUrls;
  layoutsFormattedData: FormattedPDFData[] | null;
  headerInfo: {
    studyName: string;
    creationDate: string;
    id: string;
  };
}

export const ViabilityReport: React.FC<ViabilityReportProps> = ({
  imageSources,
  layoutsFormattedData,
  headerInfo,
}) => {
  if (!layoutsFormattedData) throw Error('Dados insuficientes');
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <FrontPageHeader headerInfo={headerInfo} />

        <View style={styles.contentContainer}>
          {imageSources[0] && (
            <MapImageContainer
              title={nls.pdfReport.secionTitles.delimitated}
              imageSource={imageSources[0]}
            />
          )}
          {imageSources[1] && (
            <MapImageContainer
              title={nls.pdfReport.secionTitles.expanded}
              imageSource={imageSources[1]}
            />
          )}
        </View>
        <Logo />
      </Page>
      {layoutsFormattedData?.map((buildingLayout, index) => {
        const {
          header: { layoutNumber, characteristics },
        } = buildingLayout;
        return (
          <Page size="A4" style={styles.page} key={index}>
            <BuildingLayoutDataHeader
              layoutNumber={layoutNumber}
              characteristics={characteristics}
            />
            <View style={styles.contentContainer}>
              <BuildingLayoutData data={buildingLayout} />
            </View>
            <Logo />
          </Page>
        );
      })}
    </Document>
  );
};

interface MapImageContainerProps {
  title: string;
  imageSource: string;
}

const MapImageContainer: React.FC<MapImageContainerProps> = ({
  title,
  imageSource,
}) => {
  return (
    <View style={styles.mapImgSectionContainer}>
      <Text style={styles.mapImgTitle}>{title}</Text>
      <Image style={styles.mapImgContainer} src={imageSource} />
    </View>
  );
};
